import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../../../../../../../utils/hooks/useMutationWithError";
import {
  DisableSquareCardOnFileInput,
  useDisableSquareCardOnFileMutation,
} from "./__generated__/useDisableSquareCardOnFileMutation.graphql";

export const useDisableSquareCardOnFile = (callback: () => void) => {
  const [disableSquareCard, isDisablingSquareCard] =
    useMutationWithError<useDisableSquareCardOnFileMutation>(
      useDisableSquareCardOnFileMutationString
    );

  const { showToast } = useToast();

  const handleDisableSquareCard = (input: DisableSquareCardOnFileInput) => {
    disableSquareCard({
      variables: { input },
      onCompleted: (response) => {
        if (response.responsePayload?.success) {
          callback();
          showToast({
            description: t`Card Disabled Successfully!`,
            semanticStyle: "success",
            toastId: `square-card-disable-success`,
            testID: `square-card-disable-success`,
          });
        }
      },
    });
  };

  return [handleDisableSquareCard, isDisablingSquareCard] as const;
};

const useDisableSquareCardOnFileMutationString = graphql`
  mutation useDisableSquareCardOnFileMutation(
    $input: DisableSquareCardOnFileInput!
  ) {
    responsePayload: disableSquareCardOnFile(input: $input) {
      errors {
        field
        message: code
      }
      success
      squareCard {
        id
        cardBrand
        lastFour
        enabled
        default
        ...SquareCardFragment
        ...SelectedPaymentMethodFragment
      }
    }
  }
`;
